import { createTheme } from '@material-ui/core/styles'

export const colors = {
  darkBg: 'rgba(0,0,0,0.3)',
  backgroundGrey: '#F6F7F9',
  bgBlue: '#022E9F',
  brandBlue: '#0232AB',
  brandOrange: '#FF8500',
  errorRed: 'rgb(158, 17, 6)',
  green: '#86D735',
  lightBlue: '#01C9EB',
  lightGrey: '#EAECF4',
  textBlue: '#001344',
  textGrey: '#404040',
  white: '#fff',
}

const theme = createTheme({
  palette: {
    primary: {
      main: colors.brandOrange,
    },
    secondary: {
      main: colors.brandBlue,
    },
  },
  typography: {
    fontFamily: 'Roboto, Mont-Heavy, Mont-Bold',
    fontSize: 14,
  },
})

export default theme
